
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class ServiceManagementConfigurationApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'service-management-configuration'
    }

}
 